import OptionField from "./OptionField";
import TextField from "./TextField";
import SaporeForm from "../SaporeForm";

export default class ArticleForm extends SaporeForm {
    constructor({codeValues, nameValues}, isOptional = false, initialValues = {code: "", name: "", amount: undefined}) {
        super(isOptional)
        this._form = this._createFields({codeValues, nameValues}, isOptional, initialValues);
    }

    _createFields({codeValues, nameValues}, isOptional, initialValues) {
        let fieldsPerArticleField = {}
        fieldsPerArticleField['code'] = new OptionField(codeValues, isOptional, undefined, initialValues.code)
        fieldsPerArticleField['name'] = new OptionField(nameValues, isOptional, undefined, initialValues.name)
        fieldsPerArticleField['amount'] = new TextField(1, 4, isOptional, initialValues.amount)
        return fieldsPerArticleField
    }

    updateArticle(article) {
        this.codeField().updateValue(article.code)
        this.nameField().updateValue(article.name)
    }

    codeField() {
        return this.getFieldByName('code')
    }

    nameField() {
        return this.getFieldByName('name')
    }

    amountField() {
        return this.getFieldByName('amount')
    }

    article() {
        return {
            code: this.codeField().value,
            name: this.nameField().value,
            amount: this.amountField().value,
        }
    }

    get isValid() {
        const hasNoValues = Object.keys(this._form).every((key) => !this._form[key].hasValue)
        return hasNoValues || this.hasAllValidValues();
    }

}
